import Character from './character.vue';
import FiveADay from './five-a-day.vue';
import NutrientGroup from './nutrient-group.vue';

export default { Character, FiveADay, NutrientGroup };
